import getParentChapterId from "selectors/chapter/getParentChapterId";
import { createSelector } from "reselect";
import find from "lodash/find";

const getEntities = (state) => state.story.entities;
const getChapters = (state) => state.story.chapters;

export default createSelector(
  getChapters,
  getEntities,
  getParentChapterId,
  (chapters, entities, parentChapterId) => {
    if (parentChapterId) {
      const matchingChapterEntity = find(chapters, { id: parentChapterId });
      const matchingChapter =
        entities[matchingChapterEntity.schema][matchingChapterEntity.id];
      if (matchingChapter) {
        return matchingChapter.slugs[0];
      }
    }
    return null;
  },
);
